/* eslint-disable import/prefer-default-export */
import React, { FC } from 'react';
import { Products } from 'configs/globalConfig';
import { useTheme } from 'contexts/ThemeContext';
import classnames from 'classnames';
import routes from 'configs/routes';
import useMediaQuery from 'hooks/useMediaQuery';
import { Breakpoints } from 'configs/breakpoints';
import { getNautilusDomain, nautilusNoRedirectRoutes } from 'configs/nautilusRoutes';
import styles from './Logo.module.scss';
import LiveJasminMobile from './assets/logo_livejasmin_modelcenter_mobile.svg';
import LiveJasminDesktop from './assets/logo_livejasmin_modelcenter.png';
import LiveJasminStudioMobile from './assets/logo_livejasmin_studiocenter_mobile.svg';
import LiveJasminStudioDesktop from './assets/logo_livejasmin_studiocenter.svg';
import OranumMobile from './assets/logo_oranum_mobile.svg';
import OranumDesktop from './assets/logo_oranum.svg';

const getLogo = (theme: Products, isMobile: boolean, isStudio: boolean) => {
    switch (theme) {
        case 'livejasmin':
            if (isStudio) {
                return isMobile ? LiveJasminStudioMobile : LiveJasminStudioDesktop;
            }
            return isMobile ? LiveJasminMobile : LiveJasminDesktop;
        case 'oranum':
            return isMobile ? OranumMobile : OranumDesktop;
        default:
            throw new Error(`No logo for theme ${theme}`);
    }
};

const indexUrl = routes.dashboard;
const indexStudioUrl = routes.studioModels;

const NotLoggedInLogo: FC<LinkProps> = ({ hasLink = true, onClick }) => {
    const { theme, isLiveJasmin } = useTheme();
    const isMobile = useMediaQuery(Breakpoints.SMALL);
    const logo: string = getLogo(theme, isMobile, false);
    const indexForceDomain = isLiveJasmin ? getNautilusDomain() : '';
    const indexForceUrl = `${indexForceDomain}${nautilusNoRedirectRoutes.landing}`;

    return (
        <>
            {hasLink ? (
                <a href={indexForceUrl} onClick={onClick}>
                    <img
                        className={classnames(styles[theme], styles.logo, styles.logoNotLoggedIn)}
                        src={logo}
                        alt="Logo"
                    />
                </a>
            ) : (
                <span onClick={onClick}>
                    <img
                        className={classnames(styles[theme], styles.logo, styles.logoNotLoggedIn)}
                        src={logo}
                        alt="Logo"
                    />
                </span>
            )}
        </>
    );
};

const StudioViewLogo: FC<LogoProps> = ({ onClick }) => {
    const { theme } = useTheme();
    const isMobile = useMediaQuery(Breakpoints.SMALL);
    const logo: string = getLogo(theme, isMobile, true);
    return (
        <>
            <a href={indexStudioUrl} onClick={onClick}>
                <img className={classnames(styles[theme], styles.logo)} src={logo} alt="Logo" />
            </a>
        </>
    );
};

const LoggedInLogo: FC<LogoProps> = ({ onClick }) => {
    const { theme } = useTheme();
    const isMobile = useMediaQuery(Breakpoints.SMALL);
    const logo: string = getLogo(theme, isMobile, false);
    return (
        <>
            <a href={indexUrl} onClick={onClick}>
                <img className={classnames(styles[theme], styles.logo)} src={logo} alt="Logo" />
            </a>
        </>
    );
};

interface LinkProps extends LogoProps {
    hasLink?: boolean;
}

interface LogoProps {
    onClick: () => void;
}

export { LoggedInLogo, StudioViewLogo, NotLoggedInLogo };
